import React, { Component } from 'react';
import update from 'immutability-helper';
import Loading from '../Loading.js'
import FormList from '../../Fields/FormList.js';
import NamezzzContact from '../../Fields/NamezzzContact.js';
import { getMails, deleteMail, postMail, getApplications } from '../../Api/UserActions.js';
import { getDateString, getJsonDate, getJsonItem } from '../../Utilities/JsonFunctions.js';

declare var globalSns;

class Mailbox extends Component {
    constructor(props) {
        super(props);

        this.state = {}

        this.deleteMail = this.deleteMail.bind(this);
        this.viewMail = this.viewMail.bind(this);
        this.mailSend = this.mailSend.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    componentDidUpdate() {
        if (this.state.editId == null) {
            return;
        }

        var item = getJsonItem(this.state.mails, "historyId", this.state.editId);

        if (item == null) {
            return;
        }

        // Load html data into iframe
        var ifrm = document.getElementById("msgbody");
        ifrm = ifrm.contentWindow || ifrm.contentDocument.document || ifrm.contentDocument;
        ifrm.document.open();
        ifrm.document.write(item.message);
        ifrm.document.close();

        window.location.hash = "";
        window.location.hash = "msgbody";
    }

    loadData(id) {
        getMails((data) => {
            this.setState({
                mails: data
            }, () => {
                if (id != null) {
                    this.viewMail(id);
                }
            })
        });
        getApplications(globalSns.languageId, (data) => {
            this.setState({
                applications: data
            });
        })
    }

    deleteMail(id) {
        deleteMail(id, (ok) => {
            if (ok) {
                var item = getJsonItem(this.state.mails, "historyId", id);
                var index = this.state.mails.indexOf(item);

                this.setState({
                    mails: update(this.state.mails, {$splice: [[index, 1]]})
                })
            }
        })
    }

    viewMail(id) {
        var item = getJsonItem(this.state.mails, "historyId", id);
        var index = this.state.mails.indexOf(item);

        if (item == null) {
            return;
        }

        if (!item.isRead) {
            // set as read
            postMail(item.messageId, (data) => {})
        }

        this.setState({
            editId: id,          
            mails: update(this.state.mails, {[index]: {isRead: {$set: true}}})
        });
    }

    mailSend(id) {
        this.loadData(id);
    }

    render() {
        
        if (this.state.mails == null || this.state.applications == null) {
            return (
                <Loading/>
            );
        }

        var mails = [];

        for (var iMail = 0; iMail < this.state.mails.length; iMail++) {
            var mail = this.state.mails[iMail];
            
            var cssClass = null;
            if (!mail.isRead) {
                cssClass = "unread";
            }
            if (mail.attachments > 0) {
                cssClass += " attachments";
            }

            var itemMail = {
                id: mail.historyId, // ??
                text: 
                    <div className={cssClass}>
                        <span>{getDateString(getJsonDate(mail.received)) + "  " + mail.from}</span>
                        <br/>{mail.subject}
                    </div> 
            };
            mails.push(itemMail);
        }

        var applications = [];

        for (var iJob = 0; iJob < this.state.applications.length; iJob++) {
            var application = this.state.applications[iJob];
            var itemJob = { key: application.jobId, value: application.name }
            applications.push(itemJob);
        }

        return (
            <div className="registration">
                <div className="EditingFormTable table">
                    <NamezzzContact applications={applications} onSend={this.mailSend} />
                    <FormList values={mails} 
                        showEdit={true} showDelete={true} editClass="fa fa-search"
                        highlightId={this.state.editId} onDelete={this.deleteMail} onEdit={this.viewMail} />
                    {
                        (this.state.editId != null) ?
                            <div className="tr">
                                <div className="embed-responsive embed-responsive-16by9">
                                    <iframe id="msgbody" title="Mail" className="embed-responsive-item"></iframe>
                                </div>              
                            </div> : ""
                    }
                </div>
            </div>
        );
    }
}
                                 
export default Mailbox;


// WEBPACK FOOTER //
// ./src/Components/Pages/Mailbox.js